var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MiniSection',{attrs:{"header":this.header}},_vm._l((this.dataArray),function(obj){return _c('Icon',{key:obj.file,attrs:{"dataObj":obj}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }